import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { initDatadogRum } from "./app/datadog-rum";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

const favIcon = document.getElementById("appFavIcon") as HTMLLinkElement;
favIcon.href = `${environment.assetUrl}/favicon.ico`;

function tabLoadHandler() {
  //when loading tab. if it has session => tab reloaded. if it doesnt => duplicated/new tab
  const hash = sessionStorage.getItem("b_tab") || `tab_${+new Date()}`;
  window.b_tab = hash;

  //remove from session after copying
  sessionStorage.removeItem("b_tab");
}

function tabBeforeUnloadHandler() {
  //copy b_tab from window to session before unloading. so that it is found when load event is fired
  //browser fires this event when tab is reloaded/urlischanged(only triggered on domain change for angular)
  window.sessionStorage.b_tab = window.b_tab;
}

window.addEventListener("load", function () {
  tabLoadHandler();
});
window.addEventListener("beforeunload", function () {
  tabBeforeUnloadHandler();
});

// Initialize Datadog RUM according to environment
if (environment.datadogRum && environment.datadogRum.active) {
  initDatadogRum(environment.datadogRum);
}
